export default __webpack_public_path__ + "static/media/map.ad6c86b6.png";